import React from 'react';
import ReactToPrint from 'react-to-print';
import BitacoraSalida from './BitacoraSalida';
 
class ExportPdf extends React.Component {
     
    render() {
        const {date,fields,data} = this.props
      return (
        <div>
           <ReactToPrint
                content={() => this.componentRef}
                trigger={() =>  <label className="btn float-left impr mr-sm-2"><i className="fas fa-print"></i> Imprimir </label>}
            />
            <div style={{ display: "none" }}>
                <BitacoraSalida ref={(response) => (this.componentRef = response)} date = {date} fields = {fields} data ={data} />
            </div>
          
         
        </div>
      );
    }
}
 
export default ExportPdf;